// extracted by mini-css-extract-plugin
export default {"main":"MetricCard_main__VotEG","default":"MetricCard_default__w59Kq","green":"MetricCard_green__nGRkR","yellow":"MetricCard_yellow__MRNJm"};